import { AfterViewInit, Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';

import { CustomerUserForm } from './user.form';
import { ActivatedRoute, Router } from '@angular/router';
import { AbstractFormComponent } from '../../../../../shared/crud/component/form.component';
import { ISelectOption } from '../../../../../shared/form/element/base-select/select-option.interface';
import { SessionManager } from '../../../../../session/service/session-manager';
import { Observable } from 'rxjs';

@Component({
  templateUrl: './form.component.html',
  styleUrls: [ './form.component.scss' ]
})
export class AdminCustomerUserFormComponent extends AbstractFormComponent implements OnInit, AfterViewInit {

  campaigns$: Observable<any>;

  roles: ISelectOption[] = [
    {
      value: 'MANAGER',
      label: 'Manager'
    },
    {
      value: 'OWNER',
      label: 'Owner'
    },
    {
      value: 'EDITOR',
      label: 'Editor'
    },
    // {
    //   value: 'SUPERVISOR',
    //   label: 'Supervisor'
    // },
  ];

  constructor(formBuilder: CustomerUserForm,
              httpClient: HttpClient,
              toastrService: ToastrService,
              private sessionManager: SessionManager,
              router: Router,
              route: ActivatedRoute) {
    super(formBuilder, httpClient, toastrService, router, route);
  }


  ngAfterViewInit() {
    super.ngAfterViewInit();
    const id = this.route.snapshot.params.id.replace('new', '');
    this.formMode = id ? 'update' : 'create';
    if (this.formMode === 'update') {
      this.populate(id).subscribe();
    } else {
      this.roles = this.roles.filter(role => role.value !== 'PHOTOGRAPHER');
    }
  }

  ngOnInit() {
    super.ngOnInit();
    this.form.controls.customer.patchValue(this.route.parent.parent.snapshot.params.id);

    this.campaigns$ = Observable.create((obs) => {
      this.httpClient.get<any>('/admin/campaign', {
        params: {
          limit: '999',
          customer: this.route.parent.parent.snapshot.params.id
        }
      })
        .subscribe(
          (response) => {
            obs.next(response.rows.map((row) => {
              return <ISelectOption>{ value: row.id, label: row.name };
            }));
            obs.complete();

          },
          (error: any) => {
            obs.error(error);
            obs.complete();
          }
        );
    });
  }

  protected getUrl(): string {
    const id = this.route.snapshot.params.id.replace('new', '');
    return `/admin/user${id ? '/' + id : ''}`;
  }

  getFormData() {
    const data = { ...this.form.value };
    if (this.formMode === 'update') {
      delete data.customer;
    }
    Object.keys(data).forEach(key => {
      if (data[key] === '') {
        data[key] = null;
      }
    });
    return data;
  }

  protected onSubmit(response: any): void {
    this.toastrService.success('Saved');
    const routeId = this.route.snapshot.params.id.replace('new', '');
    if (!routeId && response.uuid) {
      this.router.navigate(['../', response.uuid], { relativeTo: this.route });
    }
  }

  back() {
    this.router.navigate([ '../' ], { relativeTo: this.route });
  }
}
